var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlameLevel6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.02 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0ba1e2;}.cls-2{fill:#dbdbdb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flame level 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.22,33.86c-2.41-2.42,2.42-9.67,2.42-9.67a7.46,7.46,0,0,0-4.83,2.42s2.41-7.26,0-9.68c0,0,0,2.42-4.84,4.84,0,0,2.42-14.51-9.68-21.77,0,0,2.42,7.26-4.83,14.51C8.62,19.35,8.62,26.61,11,29c0,0-2.42-2.41-4.84-2.41,0,0,2.42,2.41,0,7.25s0,14.45,9.58,16.91a26.18,26.18,0,0,0,11.3.74c1.61-.31,3.31-.72,3.31-.72,7.25-2.42,12.09-9.67,9.67-16.93A3.35,3.35,0,0,1,35.22,33.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.19,64H1.83a1.83,1.83,0,1,1,0-3.66H44.19a1.83,1.83,0,1,1,0,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.81,62.17c0-1,1.43-1.83,2.44-1.83H1.83a1.83,1.83,0,1,0,0,3.66H22.25C21.24,64,19.81,63.18,19.81,62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.79,60.34H15.54c1,0-.61.82-.61,1.83S16.55,64,15.54,64H37.79a1.83,1.83,0,1,0,0-3.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameLevel6);
export default __webpack_public_path__ + "static/media/Flame_level_6.64cc156e44113fa589ba0a78d333d94f.svg";
export { ForwardRef as ReactComponent };